/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Link_TravelInputs */

const en_home_footer_link_travel = /** @type {(inputs: Home_Footer_Link_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel Resources`)
};

const fr_home_footer_link_travel = /** @type {(inputs: Home_Footer_Link_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources de voyage`)
};

/**
* | output |
* | --- |
* | "Travel Resources" |
*
* @param {Home_Footer_Link_TravelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_travel = /** @type {((inputs?: Home_Footer_Link_TravelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_TravelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_travel(inputs)
	return fr_home_footer_link_travel(inputs)
});